<template>
	<div id="details-grid">
    <InventoryRecordSidebar/>
    <div id='main-panel'>
      <router-view/>
    </div>
  </div>
</template>

<script>
import InventoryRecordSidebar from './sidebar/index';

export default {
  name: 'InventoryRecords',
  components: {
    InventoryRecordSidebar,
  },
  data() {
    return {
      
    }
  },
  computed: {
    
  },
  created () {
    
  },
  methods: {

  }
}
</script>


<style scoped lang='scss'>
#details-grid {
  display: grid;
  width: 100%;
  grid-template-areas: 'sidebar main';
  grid-template-columns: minmax( 0, 3fr ) minmax( 0, 7fr );
	height: 100%;
}
@media ( min-width: 992px ) {
  #details-grid {
    grid-template-columns: minmax( 0, 1fr ) minmax( 0, 3fr );
  }
}
.records-sidebar {
  grid-area: sidebar;
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  :deep(.results) {
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
    #records-list {
      flex: 1 1 auto;
      overflow: auto;
      height: 0;
    }
  }
}
#main-panel {
  grid-area: main;
  display: flex;
  flex-flow: column nowrap;
}
</style>
